import React from 'react';

import Page from '../../components/Page';

import { getSidebarActions } from '../../sections/employee/employees/EmployeesSidebarActions';
import TableView from '../../sections/employee/generics/TableView';
import { getDataGridProps } from '../../sections/employee/employees/DatagridProps';
import EmployeesFilter from '../../sections/employee/employees/Filter';
import RowActions from '../../sections/employee/employees/RowActions';
import EmployeesProvider, { useEmployees } from '../../sections/employee/employees/EmployessContext';

export const Employees = () => <Page title="Pracownicy">
  <EmployeesProvider>
    <TableView
      sidebarActions={getSidebarActions()}
      dataGridProps={getDataGridProps() }
      FilterComponent= {EmployeesFilter}
      RowActionsComponent={RowActions}
      useCtx={useEmployees}
      showStatePanel={true}
    />
  </EmployeesProvider>
</Page>;
